export default __webpack_public_path__ + "static/media/Classwin logo_Classwin C - White.eb14dd03.svg";